import React, { useMemo } from "react";

import { AnswersByStudent, IGroup } from "../../../../../state";
import { ReactComponent as IconArrow } from "../../../../../assets/images/AnswerList/icon_arrow.svg";
import AnswerBox from "../../AnswerBox";

import styles from "./GroupAnswers.module.scss";

type Props = {
  groups: IGroup[];
  classList: number[];
  answersByStudents: AnswersByStudent[];
  setShowModalEditGroupClass: (isOpen: boolean) => void;
};

const GroupAnswers = ({
  groups,
  classList,
  answersByStudents,
  setShowModalEditGroupClass,
}: Props) => {
  const answersByGroups = useMemo(
    () =>
      groups.map(group => {
        const answerByGroups = answersByStudents.filter(
          abs => abs.student?.group_id === group.id,
        );
        return {
          ...group,
          studentAnswers: answerByGroups,
        };
      }),
    [groups, answersByStudents],
  );

  return (
    <>
      {groups.length > 0 ? (
        <>
          <div className={styles.meta}>
            <span className={styles.totalGroup}>
              合計：{groups.length}グループ
            </span>
            <button
              className={styles.groupEditButton}
              onClick={() => {
                setShowModalEditGroupClass(true);
              }}
            >
              グループを編集する
            </button>
          </div>
          <div>
            {answersByGroups.map(group => {
              const total = group.studentAnswers.length;
              const answered = group.studentAnswers.filter(a => a.haveAnswers)
                .length;

              return (
                <React.Fragment key={group.id}>
                  <div
                    className={styles.controller}
                    style={{ cursor: "pointer" }}
                    data-bs-toggle="collapse"
                    data-bs-target={`#group${group.id}`}
                    aria-expanded="false"
                    aria-controls={`group${group.id}`}
                  >
                    <div className={styles.head}>
                      <button className={styles.toggleButton}>
                        <IconArrow className={styles.iconArrow} />
                        {classList.length > 1 && (
                          <span className={styles.class}>
                            {group.klass.full_name}
                          </span>
                        )}
                        <span className={styles.group}>{group.name}</span>
                      </button>
                      <span className={styles.answerCount}>
                        {total === 0 ? "0" : `${answered}/${total}`}人回答
                      </span>
                    </div>
                  </div>
                  <div className="collapse" id={`group${group.id}`}>
                    <div className={styles.groupItem}>
                      {answered > 0 ? (
                        group.studentAnswers.map(
                          (answer, index) =>
                            answer.haveAnswers && (
                              <AnswerBox
                                key={`groupAnswer${group.id}-${index}`}
                                nameOpened={answer.nameOpened}
                                index={answer.index}
                                studentFullName={
                                  answer.student?.full_name ?? ""
                                }
                                studentNoInSchool={
                                  answer.student?.student_no_in_school ?? ""
                                }
                                studentAnswers={answer.questionAnswers}
                              />
                            ),
                        )
                      ) : (
                        <p className={styles.emptyMessageBox}>
                          まだ回答がありません。
                        </p>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </>
      ) : (
        <div className={styles.groupItem}>
          <p className={styles.emptyMessage}>まだグループがありません。</p>
          <div className={styles.buttonGroup}>
            <button
              className={styles.groupCreateButton}
              onClick={() => {
                setShowModalEditGroupClass(true);
              }}
            >
              グループを作る
            </button>
          </div>
          <p className={styles.emptyMessageBox}>まだ回答がありません。</p>
        </div>
      )}
    </>
  );
};

export default GroupAnswers;
